import axios from 'axios';

const state = {
    inventoryProducts: {},
};
    
const mutations = {
    SET_INVENTORY_PRODUCTS(state, { productId, data }) {
        console.log('Storing locations for productId', productId, data)
        if (!state.inventoryProducts) {
          state.inventoryProducts = {}
        }
        state.inventoryProducts[productId] = data
    }
};

// store/modules/inventory.js
const actions = {
    async createInventory({ dispatch }, data) {
        const userToken = localStorage.getItem('userToken');
        if (!userToken) {
            return { status: 'error', message: 'No token found' };
        }
        try {
            const baseUrl = process.env.VUE_APP_API_BASE_URL || 'http://localhost:3000/api';
            const response = await axios.post(`${baseUrl}/inventory`, data, {
                headers: { Authorization: `Bearer ${userToken}` },
            });
            return { status: 'success', message: response.data.message || 'Operation successful' };
        } catch (error) {
            let message = 'An error occurred';
            if (error.response) {
                message = error.response.data.error || message;
            }
            return { status: 'error', message };
        }
    },
    async getInventoryProducts({ commit }, product) {
        const userToken = localStorage.getItem('userToken');
        if (!userToken) {
            return { status: 'error', message: 'No token found' };
        }
        const productId = product.id;
        try {
            const baseUrl = process.env.VUE_APP_API_BASE_URL || 'http://localhost:3000/api';
            const response = await axios.get(`${baseUrl}/inventory/products/${productId}`, {
                headers: { Authorization: `Bearer ${userToken}` },
            });
            commit('SET_INVENTORY_PRODUCTS', { productId, data: response.data });
            return { status: 'success' };
        } catch (error) {
            let message = 'An error occurred';
            if (error.response) {
                message = error.response.data.error || message;
            }
            return { status: 'error', message };
        }
    },
    async createInventoryMovement({ commit }, movement) {
        const userToken = localStorage.getItem('userToken');
        if (!userToken) {
            return { status: 'error', message: 'No token found' };
        }
        console.log('Creating inventory movement:', movement);
        try {
            const baseUrl = process.env.VUE_APP_API_BASE_URL || 'http://localhost:3000/api';
            const response = await axios.post(`${baseUrl}/inventory/movements`, movement, {
                headers: { Authorization: `Bearer ${userToken}` },
            });
            commit('SET_INVENTORY_PRODUCTS', { productId, data: response.data });
            return { status: 'success' };
        } catch (error) {
            let message = 'An error occurred';
            if (error.response) {
                message = error.response.data.error || message;
            }
            return { status: 'error', message };
        }
    },
    async fetchRegulations({ commit }, action) {
        const userToken = localStorage.getItem('userToken');
        if (!userToken) {
            return { status: 'error', message: 'No token found' };
        }
        try {
            const baseUrl = process.env.VUE_APP_API_BASE_URL || 'http://localhost:3000/api';
            const response = await axios.get(`${baseUrl}/inventory/${action}`, {
                headers: { Authorization: `Bearer ${userToken}` },
            });
            commit('SET_INVENTORY_PRODUCTS', { productId, data: response.data });
            return { status: 'success' };
        } catch (error) {
            let message = 'An error occurred';
            if (error.response) {
                message = error.response.data.error || message;
            }
            return { status: 'error', message };
        }
    },
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
};